import { BuildConfig } from '@common/util-models';
import { first } from 'rxjs/operators';
import { BuildConfigService } from '../../services/build-config/build.config.service';

export const buildConfigInitializer = (
  buildConfigService: BuildConfigService
): (() => Promise<BuildConfig | undefined>) => {
  return () => buildConfigService.config$.pipe(first()).toPromise();
};
